import Vue from 'vue'
import App from './App.vue'
import router from './router'
import store from './store'
import BootstrapVue from 'bootstrap-vue'

Vue.config.productionTip = false;
Vue.use(BootstrapVue);

import 'bootstrap/dist/css/bootstrap.css'
import 'bootstrap-vue/dist/bootstrap-vue.css'

// TODO: 正しいCSS 定義をもらう
import './assets/form_custom.css'

//jQueryを読ませる
import jQuery from 'jquery'
global.jquery = jQuery;
global.$ = jQuery;
window.$ = window.jQuery = require('jquery');

//lazyloadを読ませる
import VueLazyload from 'vue-lazyload'
Vue.use(VueLazyload, {
  preLoad: 1.3,
  error: '/view/img/sample.png',
  loading: '/view/img/sample.png',
  attempt: 1
});


new Vue({
  router,
  store,
  render: h => h(App)
}).$mount('#app')
